import { EyeOutlined } from "@ant-design/icons";
import { Button, Card, Col, Row, Space, Table } from "antd";
import React from "react";
import { useTheme } from "../../../Context/ThemeContext";
import { ColumnsType } from "antd/es/table";
import Search from "antd/es/input/Search";
import BidRecivedModal from "./BidRecivedModal";

const BidsRecieved = () => {
  const { themeData } = useTheme();
  const [isModelOpen, setIsModelOpen] = React.useState<boolean>(false);

  const dataSource = [
    {
      key: "1",
      bidName: "Mike",
      age: 32,
      address: "10 Downing Street",
    },
    {
      key: "2",
      bidName: "John",
      age: 42,
      address: "10 Downing Street",
    },
  ];

  const columns: ColumnsType<any> = [
    {
      title: "Bid Id",
      dataIndex: "bidId",
      key: "bidId",
    },

    {
      title: "Bid Name",
      dataIndex: "bidName",
      key: "bidName",
    },
    {
      title: "Bid Start Date",
      dataIndex: "bidStartDate",
      key: "bidStartDate",
    },
    {
      title: "Bid End Date",
      dataIndex: "bidEndDate",
      key: "bidEndDate",
    },
    {
      title: "Bid Applied",
      dataIndex: "bidApplied",
      key: "bidApplied",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: () => (
        <>
          <Space>
            <Button
              size="small"
              style={{ padding: "1px 5px" }}
              onClick={() => setIsModelOpen(true)}
            >
              <EyeOutlined />
            </Button>
          </Space>
        </>
      ),
    },
  ];
  return (
    <>
      <div>
        <Card size="small">
          <Row>
            <Col>
              <Search />
            </Col>
          </Row>
          <Table
            className={`Tabel-style table-${
              themeData?.componentSize ?? "middle"
            }`}
            columns={columns}
            dataSource={dataSource}
            style={{ marginTop: "10px" }}
          />
        </Card>
      </div>

      {isModelOpen && (
        <BidRecivedModal
          onCancel={() => setIsModelOpen(false)}
          isModelOpen={isModelOpen}
        />
      )}
    </>
  );
};

export default BidsRecieved;
